"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollWrapper = function (_React$Component) {
    (0, _inherits3.default)(ScrollWrapper, _React$Component);

    function ScrollWrapper() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ScrollWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollWrapper.__proto__ || (0, _getPrototypeOf2.default)(ScrollWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.handleScroll = function (event) {
            // Call the passed-in prop
            if (_this.props.onWindowScroll) _this.props.onWindowScroll(event);
        }, _this.handleTouchStart = function (event) {
            // Call the passed-in prop
            if (_this.props.onTouchStart) _this.props.onTouchStart(event);
        }, _this.handleTouchMove = function (event) {
            // Call the passed-in prop
            if (_this.props.onTouchMove) _this.props.onTouchMove(event);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ScrollWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.onWindowScroll) {
                window.addEventListener("mousewheel", this.handleScroll);
                window.addEventListener("DOMMouseScroll", this.handleScroll);
                window.addEventListener('touchstart', this.handleTouchStart);
                window.addEventListener('touchmove', this.handleTouchMove);
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.props.onWindowScroll) {
                window.removeEventListener("mousewheel", this.handleScroll);
                window.removeEventListener("DOMMouseScroll", this.handleScroll);
                window.removeEventListener('touchstart', this.handleTouchStart);
                window.removeEventListener('touchmove', this.handleTouchMove);
            }
        }
    }, {
        key: "render",
        value: function render() {
            return this.props.children;
        }
    }]);
    return ScrollWrapper;
}(_react2.default.Component);

ScrollWrapper.propTypes = {
    onWindowScroll: _react2.default.PropTypes.func
};

exports.default = ScrollWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Util/ScrollWrapper.js
// module id = 809
// module chunks = 0